/* eslint-disable @typescript-eslint/naming-convention */
import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MIDDLE_END_RESTRICT_CLIENTS = createFcmDetails('middle_end_restrict_clients', {
	owner: 'Site Platform',
	context: 'Middle End',
	description: `
	Used to restrict possible values for X-Requested-With header in middle end requests.

	This is mostly useful to stop trying to process requests from very old clients (which can result in adding noise to our logs and reported errors).

	"minClientVersions" expects semver versions.

	mode:block - will block requests from clients that do not match the allowedClients or have a version lower than the minClientVersions.
	mode:warn - will log a warning for requests from clients that do not match the allowedClients or have a version lower than the minClientVersions, but will not block the request.

	⚠️ Only global group is supported.
`,
	template: {
		enabled: true,
		mode: 'block',
		allowedClients: [
			'corgi-front-end-server',
			'corgi-front-end-browser',
			'change-ios',
			'change-android',
			'http-link-change-external-api',
			'graphql-playground',
			'TestCafe',
			'optimizely',
		],
		minClientVersions: {
			'corgi-front-end-server': '0.0.0',
			'corgi-front-end-browser': '0.0.0',
			'change-ios': '0.0.0',
			'change-android': '0.0.0',
		},
	},
	import: false,
});
